import { useFormatCurrency } from '../../core/hooks/useFormatCurrency';

export const CurrencyCell = ({ value }: { value: number }) => {
  const formatCurrency = useFormatCurrency();
  return <>{formatCurrency(value)}</>;
};
